import React from "react";
import Heading from "../../components/Header/Heading";
import SectionHeading from "../../components/SectionHeading/SectionHeading";
import { ContainerWrapper, Paragraph, MissionSection, StatsGrid, StatBox } from "./About.style";

export default function About() {
  React.useEffect(() => {
    document.title = "About Us — TrixieGroup & Association";
  }, []);

  const stats = [
    { number: "500+", label: "Installations Completed" },
    { number: "10+", label: "Years Experience" },
    { number: "25", label: "Years Warranty" },
    { number: "98%", label: "Customer Satisfaction" },
  ];

  return (
    <ContainerWrapper>
      <SectionHeading>ABOUT US</SectionHeading>
      <Heading data-aos="fade-up">
        Securing Your World with{" "}
        <span className="highlight">Technology.</span>
      </Heading>

      <StatsGrid data-aos="fade-up" data-aos-delay="100">
        {stats.map((stat, index) => (
          <StatBox key={index}>
            <div className="stat-number">{stat.number}</div>
            <div className="stat-label">{stat.label}</div>
          </StatBox>
        ))}
      </StatsGrid>

      <section>
        <Paragraph data-aos="fade-up" data-aos-delay="100">
          TrixieGroup & Association is a security technology company registered with the
          primary aim of using advanced technology to solve daily security challenges.
          With over a decade of experience, we specialize in deploying cutting-edge
          security systems that protect lives, assets, and environments across Nigeria.
        </Paragraph>
        <Paragraph data-aos="fade-up" data-aos-delay="200">
          In addition to our security solutions, we provide professional Solar Inverter
          sales and installation services. We help homes and businesses transition to
          clean, affordable solar power, reducing energy costs and ensuring power
          reliability even during grid outages.
        </Paragraph>
        <Paragraph data-aos="fade-up" data-aos-delay="300">
          Our team of certified engineers and technicians bring expertise and attention
          to detail to every project. From CCTV installations to solar panel setups,
          we design systems that meet your specific needs and deliver real value.
          When you choose TrixieGroup, you're getting a partner committed to your
          safety and energy independence.
        </Paragraph>
      </section>

      <MissionSection data-aos="fade-up" data-aos-delay="400">
        <Heading as="h2">Our Mission</Heading>
        <Paragraph>
          To provide innovative security and renewable energy solutions that protect
          lives, reduce costs, and contribute to a safer, more sustainable Nigeria.
          We are committed to excellence, customer satisfaction, and using technology
          to make everyday life better.
        </Paragraph>
      </MissionSection>
    </ContainerWrapper>
  );
}
